//ajax封装
import axios from 'axios';
// import { message } from 'antd';
// import { Component } from "react";
// import cookie from 'react-cookies';
// mock数据
import mockJson from './mock/mockData';
import qs from 'qs';
import { getLanguage } from '@/utils/utils';
const language = getLanguage();
// import { getLanguageFromRedux } from '@/redux/common';
// const language = getLanguageFromRedux();
// mock开关,自动屏蔽生产环境，开发环境需要自行开关
const isMock = process.env.NODE_ENV !== 'development' ? false : true;

const base = '';
// 请求前拦截
axios.interceptors.request.use(
  config => {
    config.headers['Origin-Language'] = language;
    return config;
  },
  err => {
    console.log('请求超时');
    return Promise.reject(err);
  }
);

// 返回后拦截
axios.interceptors.response.use(
  data => {
    // 拦截ide接口，判断是否登录，没登陆跳转至登录页面
    if (data.config.url.indexOf('/api/cloudide') > -1) {
      if (data.data && data.data.code === 401)
      {window.location.href = `/${language}/l/login`;}
    }
    return data;
  },
  err => {
    console.log('err', err)
    if (err.response.status === 504 || err.response.status === 404) {
      console.log('服务器连接异常');
      // console.log("服务器被吃了⊙﹏⊙∥");
    } else if (err.response.status === 401) {
      console.log('登录信息失效：'+401);
      // 401 的时候需要返回信息，因为需要通过 该 信息判断是否跳转至登录页面
      return Promise.resolve(err.response);
      // console.log("登录信息失效⊙﹏⊙∥");
    } else if (err.response.status === 500) {
      console.log('服务器连接异常：'+500);
    }
    // message.error('服务器请求失败：'+err.response.status);
    return Promise.reject(err);
  }
);

const Http={get:'',post:'',jsonPost: '', filePost:'',postBlob:''};

Http.post=function (api,data) {
  if (isMock) { // mock功能
    if (mockJson[api] && mockJson[api].needMock) { // 兼容不需要mock的接口
      return new Promise((resolve, reject)=>{
        const resData = mockJson[api];

        setTimeout(() => {
          if (resData.status === 200) {
            resolve(resData);
          } else {
            reject(resData.error);
          }
        }, resData.pendingTime);
      });
    } 
    return new Promise((resolve, reject)=>{
      axios.post(`${base}/`+api,qs.stringify(data),{
        headers: {'Origin-Language': language }
      }).then((res)=>{
        resolve(res);
      }).catch(error => {
        reject(error);
      });
    });

  } 
  return new Promise((resolve, reject)=>{
    axios.post(`${base}/`+api,qs.stringify(data),{
      headers: {'Origin-Language': language }
    }).then((res)=>{
      resolve(res);
    }).catch(error => {
      reject(error);
    });
  });
    
};
Http.postBlob=function (api,data) {

  return new Promise((resolve, reject)=>{
    axios.post(`${base}/`+api,qs.stringify(data),{headers:{'Origin-Language': language }},{responseType: 'blob'}).then((res)=>{
      resolve(res);
    }).catch(error => {
      reject(error);
    });
  });

};
Http.getBuffer=function (api,data) {

  return new Promise((resolve, reject)=>{
    axios.get(`${base}/`+api,qs.stringify(data),{headers:{'Origin-Language': language }},{responseType: 'arraybuffer'}).then((res)=>{
      resolve(res);
    }).catch(error => {
      reject(error);
    });
  });

};
Http.get=function (api,data) {
  // console.log('zoule');
  return new Promise((resolve)=>{
    axios.get(`${base}/`+api,qs.stringify(data), {
      headers: {'Origin-Language': language }
    }).then((res)=>{
      resolve(res);
    });
  });
};

Http.getParams=function (api,data) {
  return new Promise((resolve)=>{
    axios.get(`${base}/`+api,data, {
      headers: { 'Origin-Language': language}
    }).then((res)=>{
      resolve(res);
    });
  });
};

Http.jsonGet=function (api,data) {
  return new Promise((resolve, reject)=>{
    axios.get(`${base}/`+api+'?task_id='+data.task_id,data,{
      'Origin-Language':language 
    }).then((res)=>{
      resolve(res);
    }).catch(error => {
      reject(error);
    });
  });
};

// 教研一体化平台不走量子云服务器
Http.jsonGets=function (api,data) {
  return new Promise((resolve, reject)=>{
    axios.get(api,data,{
      'Origin-Language':language 
    }).then((res)=>{
      resolve(res);
    }).catch(error => {
      reject(error);
    });
  });
};
Http.jsonPosts = (api,data) => {
  return new Promise((resolve, reject)=>{
    axios.post(api, data, {
      headers: { 'Content-Type': 'application/json','Origin-Language': language  }
    }).then((res)=>{
      resolve(res);
    }).catch(error => {
      reject(error);
    });
  });
  
};
Http.jsonDelete=function (api,data) {
  return new Promise((resolve)=>{
    axios.delete(`${base}/`+api+'?task_id='+data.task_id,data,{'Origin-Language': language }).then((res)=>{
      resolve(res);
    });
  });
};


Http.filePost=function (api,data) {
  const config = {
    headers: { 'Content-Type': 'multipart/form-data;boundary='+new Date().getTime(),'Origin-Language': language}
  };
  if(data.type===1){
    config.headers.enCoToken=data.enCoToken;
  }
  return new Promise((resolve, reject)=>{
    axios
      .post(`${base}/`+api,data,config)
      .then(function (response) {
        resolve(response);

      }).catch(function (error) {
        reject(error);
      });
    // axios.post(`${base}/`+api,data,{
    //     headers: {
    //         'Content-Type': 'multipart/form-data',
    //     },
    // }).then((res)=>{
    //     resolve(res)
    // }).catch(error => {
    //     reject(error);
    // });
  });
};
Http.jsonPost = (api, data, headerConfig={}) => {
  if (isMock) { // mock功能
    if (mockJson[api] && mockJson[api].needMock) { // 兼容不需要mock的接口
      return new Promise((resolve, reject)=>{
        const resData = mockJson[api];
        setTimeout(() => {
          if (resData.status === 200) {
            resolve(resData);
          } else {
            reject(resData.error);
          }
        }, resData.pendingTime);
      });
    } 
    return new Promise((resolve, reject)=>{
      axios.post(`${base}/`+api, data, {
        headers: {
          ...headerConfig,
          'Content-Type': 'application/json',
          'Origin-Language': language
        },
      }).then((res)=>{
        resolve(res);
      }).catch(error => {
        reject(error);
      });
    });
    
  } 
  return new Promise((resolve, reject)=>{
    axios.post(`${base}/`+api, data, {
      headers: {
        ...headerConfig,
        'aaaaaaaaaaaaa': 'aaaaaaaaaaaa',
        'Content-Type': 'application/json;charset=utf-8',
        'Origin-Language': language
      }
    }).then((res)=>{
      resolve(res);
    }).catch(error => {
      reject(error);
    });
  });
  
};
Http.jsonPostSignal = (api, data, signal) => {
  if (isMock) { // mock功能
    if (mockJson[api] && mockJson[api].needMock) { // 兼容不需要mock的接口
      return new Promise((resolve, reject)=>{
        const resData = mockJson[api];
        setTimeout(() => {
          if (resData.status === 200) {
            resolve(resData);
          } else {
            reject(resData.error);
          }
        }, resData.pendingTime);
      });
    } 
    return new Promise((resolve, reject)=>{
      axios.post(`${base}/`+api, data, {
        headers: {
          'Content-Type': 'application/json',
          'Origin-Language': language
        },
        signal: signal,
      }).then((res)=>{
        resolve(res);
      }).catch(error => {
        reject(error);
      });
    });
    
  } 
  return new Promise((resolve, reject)=>{
    axios.post(`${base}/`+api, data, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Origin-Language': language
      },
      signal: signal,
    }).then((res)=>{
      resolve(res);
    }).catch(error => {
      reject(error);
    });
  });
  
};
export default Http;
